import { gql } from '@apollo/client';
export const CLIENT_FIELDS = gql `
  fragment GlobalClientFields on GlobalClient {
    id
    code
    name
    employerId
    createdAt
    updatedAt
    countryName
    logoS3Key
    isActive
    guildEmployerUuid
    isParent
    parentId
    parentName
    clientConfig {
      id
      clientId
      locale
      currency
      country
      timezone
      extraData
    }
  }
`;
export const CLIENTS = gql `
  ${CLIENT_FIELDS}
  query CLIENTS($spec: ClientSpec!) {
    clients(spec: $spec) {
      total
      page
      pageSize
      items {
        ...GlobalClientFields
      }
    }
  }
`;
export const SAVE_CLIENT = gql `
  ${CLIENT_FIELDS}
  mutation SAVE_CLIENT($input: ClientInput!) {
    saveClient(input: $input) {
      success
      client {
        ...GlobalClientFields
      }
      messages {
        value
        type
        params
      }
    }
  }
`;
export const CURRENT_CLIENT = gql `
  ${CLIENT_FIELDS}
  query CURRENT_CLIENT {
    currentClient {
      ...GlobalClientFields
    }
  }
`;
export const SYSTEM_CLIENT_ID = gql `
  query SystemClientId {
    systemClientId
  }
`;
export const DOWNLOAD_CLIENT_CONFIGURATIONS = gql `
  query DOWNLOAD_CLIENT_CONFIGURATIONS($clientId: Int!) {
    downloadClientConfigurations(clientId: $clientId)
  }
`;
export const UPLOAD_CLIENT_CONFIGURATIONS = gql `
  query UPLOAD_CLIENT_CONFIGURATIONS($clientId: Int!, $s3Key: String!) {
    uploadClientConfigurations(clientId: $clientId, s3Key: $s3Key) {
      success
      messages {
        value
        type
        params
      }
    }
  }
`;
export const IS_CLIENT_USING_GUILD_AUTH = gql `
  query IS_CLIENT_USING_GUILD_AUTH($clientCode: String!) {
    isClientUsingGuildAuth(clientCode: $clientCode)
  }
`;
